var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/"}},[_c('div',{staticClass:"left"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/beyounger/logo.png"),"alt":"Aclhemy Pay"}}),_c('span',{staticClass:"name"},[_vm._v("BEYOUNGER")])])])
}]

export { render, staticRenderFns }